/*
 * Header search panel.
 * - On focus (empty box): best sellers on the right, categories on the left.
 * - Hover or keyboard-focus a category: its products replace the right column instantly
 *   (pre-rendered <template>s in snippets/vs-header-search.liquid, no request).
 * - Typing (1+ letters): live results rendered by sections/vs-predictive-search.liquid through
 *   Shopify's /search/suggest endpoint, cached per query.
 * No dependencies. Styles: assets/vs-header.css
 */
(function () {
  var DELAY = 120;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setup(form) {
    if (form.dataset.vsReady) return;
    form.dataset.vsReady = 'true';

    var input = form.querySelector('.vs-search__input');
    var panel = form.querySelector('.vs-search__panel');
    var main = form.querySelector('[data-vs-main]');
    var suggestions = form.querySelector('[data-vs-suggestions]');
    var categories = form.querySelector('[data-vs-categories]');
    var clear = form.querySelector('.vs-search__clear');
    var sectionId = form.getAttribute('data-vs-section');
    var cache = {};
    var timer = null;
    var controller = null;
    var query = '';
    var resultsMain = null; // the right column for the current query, to return to after a category hover
    var active = -1;
    var optionCount = 0;

    function view(name) {
      var template = form.querySelector('template[data-vs-view="' + name + '"]');
      return template ? template.content.cloneNode(true) : null;
    }

    function fill(target, content) {
      target.textContent = '';
      if (content) target.appendChild(content);
      tagOptions();
    }

    function tagOptions() {
      active = -1;
      input.removeAttribute('aria-activedescendant');
      optionCount = 0;
      options().forEach(function (option) {
        option.id = 'VsSearchOption-' + optionCount++;
        option.classList.remove('is-active');
        option.setAttribute('aria-selected', 'false');
      });
    }

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function setCategory(handle) {
      categories.querySelectorAll('[data-vs-category]').forEach(function (link) {
        link.classList.toggle('is-current', link.getAttribute('data-vs-category') === handle);
      });
    }

    function open() {
      if (!panel.hidden) return;
      panel.hidden = false;
      form.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      form.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function showDefault() {
      resultsMain = null;
      suggestions.textContent = '';
      setCategory(null);
      fill(main, view('default'));
    }

    function showCategory(handle) {
      var content = view(handle);
      if (!content) return;
      setCategory(handle);
      fill(main, content);
    }

    function restore() {
      setCategory(null);
      if (resultsMain) {
        fill(main, resultsMain.cloneNode(true));
      } else if (!query) {
        fill(main, view('default'));
      }
    }

    function showResults(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var aside = doc.querySelector('[data-vs-part="aside"]');
      var results = doc.querySelector('[data-vs-part="main"]');
      if (!results) return;
      resultsMain = document.createDocumentFragment();
      Array.prototype.slice.call(results.childNodes).forEach(function (node) {
        resultsMain.appendChild(document.importNode(node, true));
      });
      if (resultsMain.querySelector('[data-vs-empty]')) addFallback(resultsMain);
      suggestions.textContent = '';
      if (aside) {
        Array.prototype.slice.call(aside.childNodes).forEach(function (node) {
          suggestions.appendChild(document.importNode(node, true));
        });
      }
      setCategory(null);
      fill(main, resultsMain.cloneNode(true));
      open();
    }

    // Instant first pass: every product already in the pre-rendered panels, matched by name
    // while the full server results are on their way.
    var localIndex = null;
    function buildIndex() {
      localIndex = [];
      var seen = {};
      form.querySelectorAll('template[data-vs-view]').forEach(function (template) {
        template.content.querySelectorAll('.vs-ps__item').forEach(function (item) {
          var link = item.querySelector('.vs-ps__card');
          var href = link && link.getAttribute('href');
          if (!href || seen[href]) return;
          seen[href] = true;
          localIndex.push({ text: item.textContent.toLowerCase(), node: item });
        });
      });
    }
    function showLocal(term) {
      if (!localIndex) buildIndex();
      var words = term.toLowerCase().split(/\s+/);
      var matches = localIndex.filter(function (entry) {
        return words.every(function (word) { return entry.text.indexOf(word) !== -1; });
      }).slice(0, 6);
      if (!matches.length) return;
      var fragment = document.createDocumentFragment();
      var heading = document.createElement('p');
      heading.className = 'vs-ps__heading';
      heading.textContent = 'Products';
      fragment.appendChild(heading);
      var grid = document.createElement('ul');
      grid.className = 'vs-ps__grid';
      matches.forEach(function (entry) { grid.appendChild(entry.node.cloneNode(true)); });
      fragment.appendChild(grid);
      setCategory(null);
      fill(main, fragment);
    }

    // No match: add three best sellers from the pre-rendered default list under "You might like".
    function addFallback(target) {
      var defaults = view('default');
      var grid = defaults && defaults.querySelector('.vs-ps__grid');
      if (!grid) return;
      var items = grid.querySelectorAll('.vs-ps__item');
      for (var i = items.length - 1; i >= 3; i--) items[i].remove();
      var heading = document.createElement('p');
      heading.className = 'vs-ps__heading';
      heading.textContent = 'You might like';
      target.appendChild(heading);
      target.appendChild(grid);
    }

    function fetchResults(term) {
      if (cache[term]) {
        showResults(cache[term]);
        return;
      }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      form.classList.add('is-loading');
      var url = root + 'search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&section_id=' + encodeURIComponent(sectionId);
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.text();
        })
        .then(function (html) {
          cache[term] = html;
          if (term === query) showResults(html);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError' && term === query) {
            fill(main, null);
            var note = document.createElement('p');
            note.className = 'vs-ps__empty-tip';
            note.textContent = 'Search is unavailable right now. Press Enter to see all results.';
            main.appendChild(note);
          }
        })
        .then(function () {
          if (term === query) form.classList.remove('is-loading');
        });
    }

    function highlight(index) {
      var list = options();
      if (!list.length) return;
      if (active > -1 && list[active]) {
        list[active].classList.remove('is-active');
        list[active].setAttribute('aria-selected', 'false');
      }
      active = (index + list.length) % list.length;
      var current = list[active];
      current.classList.add('is-active');
      current.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
      var handle = current.getAttribute('data-vs-category');
      if (handle) showCategoryKeepFocus(handle, current);
    }

    function showCategoryKeepFocus(handle, link) {
      // Swap the right column without losing the highlighted category on the left.
      var content = view(handle);
      if (!content) return;
      setCategory(handle);
      main.textContent = '';
      main.appendChild(content);
      var index = options().indexOf(link);
      optionCount = 0;
      options().forEach(function (option) { option.id = 'VsSearchOption-' + optionCount++; });
      active = index;
      input.setAttribute('aria-activedescendant', link.id);
    }

    // First time the search box is used, fetch the category photos in the background so hovering
    // a category shows its products immediately. Not done on page load, to keep the page light.
    var warmed = false;
    function warmImages() {
      if (warmed) return;
      warmed = true;
      form.querySelectorAll('template[data-vs-view]').forEach(function (template) {
        template.content.querySelectorAll('img').forEach(function (img) {
          var preload = new Image();
          preload.sizes = img.getAttribute('sizes') || '';
          preload.srcset = img.getAttribute('srcset') || '';
          preload.src = img.getAttribute('src');
        });
      });
    }

    input.addEventListener('focus', function () {
      if (!input.value.trim()) showDefault();
      open();
      warmImages();
    });

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clear.hidden = !input.value;
      clearTimeout(timer);
      query = term;
      if (!term) {
        form.classList.remove('is-loading');
        if (controller) controller.abort();
        showDefault();
        open();
        return;
      }
      open();
      if (cache[term]) {
        showResults(cache[term]);
        return;
      }
      showLocal(term);
      timer = setTimeout(function () { fetchResults(term); }, DELAY);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        open();
        highlight(active + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(active - 1);
      } else if (event.key === 'Enter' && active > -1) {
        var list = options();
        if (list[active]) {
          event.preventDefault();
          window.location.href = list[active].href;
        }
      } else if (event.key === 'Escape') {
        close();
      }
    });

    categories.addEventListener('mouseover', function (event) {
      var link = event.target.closest('[data-vs-category]');
      if (link && !link.classList.contains('is-current')) showCategory(link.getAttribute('data-vs-category'));
    });
    categories.addEventListener('mouseleave', restore);

    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      query = '';
      showDefault();
      input.focus();
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) close();
    });
    form.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !form.contains(event.relatedTarget)) close();
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) event.preventDefault();
    });

    clear.hidden = !input.value;
  }

  function init() {
    document.querySelectorAll('[data-vs-search]').forEach(setup);
  }

  // Loaded async after the header markup, so the form is already in the page.
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
})();
